<template>
  <div class="tables" style="width: 100%">
    <el-table
        class="tableAuto"
        v-loading="contactLoading"
        :data="tableData"
        style="width: 100%"
        :cell-style="rowClassName"
        :header-cell-style="headerClassName"
        @cell-mouse-leave="clearVisiblePopover"
    >
      <el-table-column
          v-for="(item, index) in targetMaps"
          :key="item.key"
          :label="item.key"
          :prop="item.value"
          label="Date"
          :width="handleClickSelectWidth(item)"
      >
        <template v-if="item.value==='remark'" #default="scope">
          <el-icon
              :color="scope.row.remark ? '#40a9ff' : '#dddddd'">
            <el-tooltip
                v-if="scope.row.remark"
                class="box-item"
                :content="scope.row.remark"
                placement="right"
                popper-class="tips_width"
            >
              <Memo/>
            </el-tooltip>
            <Memo v-else/>
          </el-icon>
        </template>
        <template v-else-if="item.value==='name'" #default="{row}">
          <div style="display: flex;align-items: center;">
            <el-icon v-if="row?.isMain" style="margin-right: 5px;">
              <User/>
            </el-icon>
            <div :ref="ref => (refMap[`${row.email}name`] = ref)"
                 @mouseover.stop="handleRef(refMap[`${row.email}name`], row, 1)"
                 class="over_normal"
                 v-if=" getTextLength(row.name) > sizeMaxNumber"
                 :key="row.name">
              {{
                getTextLength(row.name) > sizeMaxNumber ? formatText(row.name, sizeMaxNumber) : row.name
              }}
            </div>
            <div v-else class="over_normal">
              {{ row.name }}
            </div>
          </div>
        </template>
        <template v-else-if="item.value==='nickName'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}nickName`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}nickName`], row, 2)"
               class="over_normal"
               v-if=" getTextLength(row.nickName) > sizeMaxNumber"
               :key="row.nickName">
            {{
              getTextLength(row.nickName) > sizeMaxNumber ? formatText(row.nickName, sizeMaxNumber) : row.nickName
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.nickName }}
          </div>
        </template>
        <template v-else-if="item.value==='email'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}email`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}email`], row, 3)"
               class="over_normal"
               v-if=" getTextLength(row.email) > sizeMaxNumber"
               :key="row.email">
            {{
              getTextLength(row.email) > sizeMaxNumber ? formatText(row.email, sizeMaxNumber) : row.email
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.email }}
          </div>
        </template>
        <template v-else-if="item.value==='departName'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}departName`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}departName`], row, 4)"
               class="over_normal"
               v-if=" getTextLength(row.departName) > sizeMaxNumber"
               :key="row.departName">
            {{
              getTextLength(row.departName) > sizeMaxNumber ? formatText(row.departName, sizeMaxNumber) : row.departName
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.departName }}
          </div>
        </template>
        <template v-else-if="item.value==='post'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}post`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}post`], row, 5)"
               class="over_normal"
               v-if=" getTextLength(row.post) > sizeMaxNumber"
               :key="row.post">
            {{
              getTextLength(row.post) > sizeMaxNumber ? formatText(row.post, sizeMaxNumber) : row.post
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.post }}
          </div>
        </template>
        <template v-else-if="item.value==='contactPhone'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}contactPhone`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}contactPhone`], row, 6)"
               class="over_normal"
               v-if=" getTextLength(row.contactPhone) > sizeMaxNumber"
               :key="row.contactPhone">
            {{
              getTextLength(row.contactPhone) > sizeMaxNumber ? formatText(row.contactPhone, sizeMaxNumber) : row.contactPhone
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.contactPhone }}
          </div>
        </template>
        <template v-else-if="item.value==='birthday'" #default="{row}">
          <div>
            {{ row.birthday ? row.birthday.split(" ")[0] : "" }}
          </div>
        </template>
        <template v-else-if="item.value==='createTime'" #default="{row}">
          <div :ref="ref => (refMap[`${row.email}createTime`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.email}createTime`], row, 7)"
               class="over_normal"
               v-if=" getTextLength(row.createTime) > sizeMaxNumber"
               :key="row.createTime">
            {{
              getTextLength(row.createTime) > sizeMaxNumber ? formatText(row.createTime, sizeMaxNumber) : row.createTime
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.createTime }}
          </div>
        </template>
        <template v-else-if="item.value==='whatsAppPhone'" #default="{row}">
          <div style="width: 100%;display: flex;align-items: center;justify-content: flex-start;gap: 5px;">
            <div
                :ref="ref => (refMap[`${row.email}whatsAppPhone`] = ref)"
                @mouseover.stop="handleRef(refMap[`${row.email}whatsAppPhone`], row, 8)"
                class="over_normal"
                v-if=" getTextLength(row.whatsAppPhone) > sizeMaxNumber"
                :key="row.whatsAppPhone"
                style="flex: 1;min-width: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
            >
              {{
                getTextLength(row.whatsAppPhone) > sizeMaxNumber ? formatText(row.whatsAppPhone, sizeMaxNumber) : row.whatsAppPhone
              }}
            </div>
            <div
                v-else
                class="over_normal"
                style="flex: 1;min-width: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
            >
              {{ row.whatsAppPhone || '' }}
            </div>

            <svg
                v-if="row.whatsAppPhone"
                :style="{ cursor: 'pointer', flex: '0 0 auto' }"
                @click.stop="handleGoWhatsApp(row.whatsAppPhone)"
                t="1773383305990" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4800" width="20" height="20">
              <path
                  d="M511.872427 0h0.256C794.45376 0 1024.000427 229.674667 1024.000427 512s-229.589333 512-511.872 512c-104.106667 0-200.704-31.018667-281.6-84.565333L33.707093 1002.325333l63.786667-190.250666A508.245333 508.245333 0 0 1 0.000427 512C0.000427 229.674667 229.58976 0 511.872427 0zM365.39776 281.429333c-9.770667-23.338667-17.194667-24.234667-32-24.832A285.525333 285.525333 0 0 0 316.50176 256c-19.285333 0-39.424 5.632-51.626667 18.048C250.155093 289.109333 213.33376 324.266667 213.33376 396.501333c0 72.149333 52.778667 141.952 59.861333 151.722667 7.424 9.728 102.912 160 251.093334 221.226667 115.925333 47.914667 150.314667 43.477333 176.725333 37.845333 38.528-8.277333 86.826667-36.693333 98.986667-70.954667 12.16-34.346667 12.16-63.616 8.618666-69.845333-3.584-6.186667-13.354667-9.728-28.16-17.152-14.848-7.381333-86.869333-42.88-100.522666-47.616-13.354667-4.992-26.069333-3.242667-36.138667 10.965333-14.250667 19.797333-28.16 39.936-39.466667 52.053334-8.874667 9.472-23.424 10.666667-35.541333 5.632-16.298667-6.826667-61.952-22.784-118.314667-72.789334-43.562667-38.741333-73.216-86.954667-81.792-101.418666-8.618667-14.805333-0.896-23.381333 5.930667-31.36 7.381333-9.173333 14.506667-15.658667 21.930667-24.234667 7.424-8.576 11.52-13.013333 16.298666-23.082667 5.034667-9.770667 1.493333-19.84-2.090666-27.221333-3.541333-7.381333-33.194667-79.573333-45.354667-108.8z"
                  fill="#25D366" p-id="4801"></path>
            </svg>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.operate')" width="150">
        <template #default="{ row, column, $index }">
          <el-button size="small" type="primary" link @click="handleClickHistroy(row)">{{
              $t('common.contact.record')
            }}
          </el-button>
          <el-button
              type="primary"
              link
              size="small"
              @click="clickEdit(row, column, $index)"
          >{{ $t('common.edit') }}
          </el-button
          >
          <ConfirmDeletePopover
              :visible="row.popoverVisible"
              :width="168"
              :message="$t('sys.message.ask.contect.delete')"
              @update:visible="(value) => (row.popoverVisible = value)"
              @confirm:delete="handleDelete(row, column, $index)"
          >
            <template #settings>
              <el-button size="small" type="danger" link @click="handleDeleteT(row, column, $index)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </ConfirmDeletePopover>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
      </template>
    </el-table>
    <div class="pages" style="margin-top: 15px">
      <el-pagination
          v-model:current-page="pageNo"
          v-model:page-size="pageSize"
          v-if="total"
          layout="total, prev, pager, next"
          :total="total"
          size="small"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      effect="dark"
      :show-after="1200"
  >
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.name }}
      </div>
    </template>
    <template v-if="popoverType === 2">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.nickName }}
      </div>
    </template>
    <template v-if="popoverType === 3">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.email }}
      </div>
    </template>
    <template v-if="popoverType === 4">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.departName }}
      </div>
    </template>
    <template v-if="popoverType === 5">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.post }}
      </div>
    </template>
    <template v-if="popoverType === 6">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.contactPhone }}
      </div>
    </template>
    <template v-if="popoverType === 7">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.createTime }}
      </div>
    </template>
    <template v-if="popoverType === 8">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.whatsAppPhone }}
      </div>
    </template>
  </el-popover>

</template>
<script setup>
import {ref, computed, reactive, onMounted, nextTick, defineEmits} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {ElMessage} from "element-plus";

import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {i18n} from "@/lang";
import {ElTable} from "element-plus";
import {Memo, User} from "@element-plus/icons-vue";
import {flexWidth} from "@/utils/tableWidth";
import {getTextLength} from "@/utils/util";
import {formatText} from "../../../utils/util";
import {debouncePlus} from "@/utils/mylodash";
import sessionStore from "@/utils/sessionStore";
import { normalizeWhatsAppId } from "@/utils/whatsapp";
import {getLidAndUsByPhone} from "@/api/whatsapp";

const router = useRouter();
const store = useStore();
const tableData = computed(() => store.state.customer.contactList);
const pageSize = computed(() => store.state.customer.contactPage.pageSize);
const pageNo = computed(() => store.state.customer.contactPage.pageNo);
const total = computed(() => store.state.customer.contactPage.total);
const contactLoading = computed(() => store.state.customer.contactLoading);

const emit = defineEmits(["clickEdit"]);

const handleCurrentChange = (page) => {
  store.commit("customer/setContactPage", {
    total: total.value,
    pageNo: page,
    pageSize: pageSize.value,
  });
  store.dispatch("customer/getContactList");
};

const targetMaps = [
  {key: i18n.global.t('common.name'), value: "name"},
  {key: i18n.global.t('common.user.nick1'), value: "nickName"},
  {key: i18n.global.t('common.emailbox'), value: "email"},
  {key: i18n.global.t('common.department'), value: "departName"},
  {key: i18n.global.t('common.position'), value: "post"},
  {key: i18n.global.t('common.contact.phone'), value: "contactPhone"},
  {key: i18n.global.t('whatsapp.title'), value: "whatsAppPhone"},
  {key: i18n.global.t('common.birthday'), value: "birthday"},
  {key: i18n.global.t('common.record.time'), value: "createTime"},
  {key: i18n.global.t('common.remark'), value: "remark"},
];

const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item) => {
  if (item.value === 'birthday') {
    return 100
  } else if (item.value === 'createTime') {
    return 150
  } else if (item.value === 'remark') {
    return 100
  }
  // if (item.value === "name") {
  //   return flexWidth('name', tableData.value, i18n.global.t('common.name')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('name', tableData.value, i18n.global.t('common.name')) + 20
  // } else if (item.value === 'nickName') {
  //   return flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) + 20
  // } else if (item.value === 'email') {
  //   return flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) + 20
  // } else if (item.value === 'departName') {
  //   return flexWidth('departName', tableData.value, i18n.global.t('common.department')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('departName', tableData.value, i18n.global.t('common.department')) + 20
  // } else if (item.value === 'post') {
  //   return flexWidth('post', tableData.value, i18n.global.t('common.position')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('post', tableData.value, i18n.global.t('common.position')) + 20
  // } else if (item.value === 'contactPhone') {
  //   return 160
  // } else if (item.value === 'birthday') {
  //   return 160
  // } else if (item.value === 'createTime') {
  //   return flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) + 20
  // }
}

// const handleClickSelectMinWidth = (item, type) => {
//   if (item.value === 'remark') {
//     return 80
//   } else {
//     return 160
//   }
// }

// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)

onMounted(async () => {
  const customerId = router.currentRoute.value.params.userId;
  sessionStore.set("customerId", customerId);
  await store.dispatch("customer/getContactList");
});

const popoverVisible = ref(false);
const handleDelete = async (row, column, $index) => {
  await store.dispatch("customer/deleteContact", {id: row.id});
  await store.dispatch("customer/getContactList");
  row.popoverVisible = false;
};
const handleDeleteT = async (row, column, $index) => {
  row.popoverVisible = true;
}

const handleClickHistroy = (row) => {
  emit('clickHistory', {history: true, item: row})
}

const clickEdit = (row, column, $index) => {
  emit("clickEdit", {row, column, $index});
};


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

const handleGoWhatsApp = async (whatsappId) => {
  const normalized = normalizeWhatsAppId(whatsappId)
  if (!normalized) return;

  let lid = ''
  let pn = ''
  try {
    const res = await getLidAndUsByPhone({phone: normalized})
    const result = res?.result || res?.data?.result || null
    lid = String(result?.lid || '')
    pn = String(result?.pn || '')
    if (!lid) {
      ElMessage.warning('该手机号未注册 WhatsApp 或不可用')
      return
    }
  } catch (e) {
    ElMessage.error(e?.message || '查询 WhatsApp 账号失败')
    return
  }

  router.push({
    name: 'WAHome',
    query: {
      whatsappId: normalized,
    },
  });

  const chatIdToOpen = pn || lid || normalized
  try {
    // Allow WAHome to mount first, then request to open chat.
    // WAHome has openChatByChatId() which can resolve rooms even if not in current page.
    window.setTimeout(() => {
      try {
        window.dispatchEvent(new CustomEvent('wa-open-chat', {detail: {chatId: chatIdToOpen}}))
      } catch (e) {
      }
    }, 350)
  } catch (e) {
  }
}

</script>
<style lang="less" scoped>
@import "../../../less/page.less";

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

.tableAuto.el-table .cell {
  white-space: nowrap;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}
</style>
